import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        
        <a
          className="App-link"
          href="mailto:l4developmentnc@gmail.com?subject=Inquiry%20from%20L4%20Promos&body=Hi%20Mitch%2C%0A%0AI'd%20like%20to%20learn%20more%20about%20your%20services."
        >
          Email Mitch
        </a>

      </header>
    </div>
  );
}

export default App;
